





















import { TcPageAlert } from '@telia/shared-ui-components'
import { defineComponent } from '@vue/composition-api'

export default defineComponent({
  components: {
    TcPageAlert
  },
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    exception: {
      type: Boolean,
      required: true
    },
    exceptionMessage: {
      type: String,
      default: 'Misslyckades att ladda information...'
    },
    infoMessage: {
      type: String,
      default: 'Laddar information...'
    }
  }
})
